import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-meter-stock-decommissioned-layout',
  templateUrl: './meter-stock-decommissioned-layout.component.html',
  styleUrls: ['./meter-stock-decommissioned-layout.component.scss']
})
export class MeterStockDecommissionedLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
